<template>
    <div class="page">
        <div class="paper-shell">
            <div class="window-bar">
                <div class="window-title">考试练习版</div>
                <div class="window-actions">
                    <div class="window-btn small"></div>
                    <div class="window-btn square"></div>
                    <div class="window-btn close"></div>
                </div>
            </div>

            <div class="exam-topbar">
                <div class="exam-line first">
                    <span class="exam-item">当前试室：第一试室</span>
                    <span class="exam-item">当前场次：第00场</span>
                    <span class="exam-item seat">座位号：<span class="seat-highlight">1</span></span>
                    <div class="legend-row">
                        <div v-for="(item, index) in legendList" :key="index" class="legend-item">
                            <div class="legend-box" :class="item.className"></div>
                            <span>{{ item.label }}</span>
                        </div>
                    </div>
                </div>

                <div class="exam-line second">
                    <span class="exam-item">姓名：测试考生</span>
                    <span class="exam-item">性别：男</span>
                    <span class="exam-item">准考证号：1001</span>
                    <span class="exam-item">报考专业：测试专业</span>
                </div>
            </div>

            <div class="main-layout">
                <div class="question-panel">
                    <div class="question-material" v-if="question.material" v-html="question.material"></div>
                    <div class="question-card">
                        <div class="question-no">第{{ index }}题</div>
                        <div class="question-body" v-html="question.title"></div>
                    </div>
                    <div class="answer-panel">
                        <div @click="selectRadio(item.key)" v-for="(item, index) in question.select_list" :key="index"
                            class="option-row" :class="question.user_answer == item.key ? 'active' : ''">
                            <span class="option-key">{{ item.key }}</span>
                            <div class="option-radio" :class="question.user_answer == item.key ? 'active' : ''"></div>
                            <span class="option-span" v-html="item.value"></span>
                        </div>
                    </div>

                    <div class="action-row">
                        <div class="action-btn" @click="nextQuestion(index - 1)">
                            <img src="https://www.yitku.com//new_app/exam/yw_09.png" />
                        </div>
                        <div class="action-btn" @click="nextQuestion(index + 1)">
                            <img src="https://www.yitku.com//new_app/exam/yw_10.png" />
                        </div>
                        <div class="action-btn" @click="dialogVisible = true">
                            <img src="https://www.yitku.com//new_app/exam/yw_11.png" />
                        </div>
                        <div class="action-btn" @click="showHelp()">
                            <img src="https://www.yitku.com//new_app/exam/yw_12.png" />
                        </div>
                        <div class="action-btn" @click="paperSubmit()">
                            <img src="https://www.yitku.com//new_app/exam/yw_13.png" />
                        </div>
                    </div>

                    <div class="bottom-status">
                        <div class="time-group">
                            <span>考试总时间：</span>
                            <span class="time-highlight">{{ totalTimes }}</span>
                            <span class="gap-space">剩余时间：</span>
                            <span class="time-highlight">{{ countSecond }}</span>
                        </div>

                        <div class="progress-group">
                            <span class="progress-meta">总题数：{{ questionData.length }}</span>
                            <span class="progress-meta">已答[{{ answeredCount }}]题</span>
                            <div class="progress-line">
                                <div class="progress-fill" :style="'width:' + this.adminApi.getPercent(answeredCount,
                                    questionData.length) + '%'"></div>
                            </div>
                            <span class="progress-percent">{{ this.adminApi.getPercent(answeredCount,
                                questionData.length) }}%</span>
                        </div>
                    </div>
                </div>

                <div class="sheet-panel">

                    <div class="sheet-card">
                        <div class="sheet-header" @click="radioChange">
                            <span>单选题</span>
                            <span class="sheet-arrow">
                                <i v-if="radio" class="el-icon-arrow-down"></i>
                                <i v-else class="el-icon-arrow-up"></i>
                            </span>
                        </div>
                        <div class="sheet-grid" v-if="radio">
                            <div @click="nextQuestion(item)" v-for="item in jsonData.radio" :key="item"
                                class="sheet-number" :class="index == item
                                    ? ' doing'
                                    : questionData[item - 1].user_answer_right != -1
                                        ? ' done'
                                        : ' todo'
                                    ">
                                {{ item }}
                            </div>
                        </div>
                    </div>

                    <div class="sheet-card">
                        <div class="sheet-header" @click="indefiniteChange">
                            <span>共用题干单选题</span>
                            <span class="sheet-arrow">
                                <i v-if="indefinite" class="el-icon-arrow-down"></i>
                                <i v-else class="el-icon-arrow-up"></i>
                            </span>
                        </div>

                        <div class="sheet-grid" v-if="indefinite">
                            <div @click="nextQuestion(jsonData.radio + item)" v-for="item in jsonData.indefinite"
                                :key="item" class="sheet-number" :class="index == jsonData.radio + item
                                    ? ' doing'
                                    : questionData[jsonData.radio + item - 1].user_answer_right != -1
                                        ? ' done'
                                        : ' todo'
                                    ">
                                {{ jsonData.radio + item }}
                            </div>
                        </div>
                    </div>

                    <div class="sheet-card">
                        <div class="sheet-header" @click="compatibilityChange">
                            <span>共用备选答案单选题</span>
                            <span class="sheet-arrow">
                                <i v-if="compatibility" class="el-icon-arrow-down"></i>
                                <i v-else class="el-icon-arrow-up"></i>
                            </span>
                        </div>
                        <div class="sheet-grid" v-if="compatibility">
                            <div @click="nextQuestion(jsonData.radio + jsonData.indefinite + item)"
                                v-for="item in jsonData.compatibility" :key="item" class="sheet-number" :class="index == jsonData.radio + jsonData.compatibility + item
                                    ? ' doing'
                                    : questionData[jsonData.radio + jsonData.indefinite + item - 1].user_answer_right != -1
                                        ? ' done'
                                        : ' todo'
                                    ">
                                {{ jsonData.radio + jsonData.indefinite + item }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="科学计算器" :modal="false" :modal-append-to-body="false" :close-on-click-modal="false" v-dialogDrag
            :visible.sync="dialogVisible" width="720px" :before-close="handleClose">
            <iframe src="https://www.yitku.com/calc" frameborder="0" width="100%" height="350"></iframe>
        </el-dialog>

        <div class="window" v-if="showSubmit">
            <div class="hs"></div>
            <div class="windowContent">
                <p class="tishi" v-if="tbox == 99"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />试卷描述</p>
                <p class="tishi" v-if="tbox == 98"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />信息提示</p>
                <p class="tishi" v-if="tbox == 97"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />信息提示</p>
                <p class="tishi" v-if="tbox == 96"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />帮助</p>
                <p class="tishi" v-if="tbox == 95"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />信息提示</p>
                <p class="tishi" v-if="tbox == 0"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />判断题</p>
                <p class="tishi" v-if="tbox == 1"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />单选题</p>
                <p class="tishi" v-if="tbox == 2"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />多选题</p>
                <p class="tishi" v-if="tbox == 3"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />材料题</p>
                <p class="tishi" v-if="tbox == 4"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />共用题干单选题</p>
                <p class="tishi" v-if="tbox == 5"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />共用备选答案单选题
                </p>
                <div class="delete">
                    <div class="infoTest icon" v-if="tbox == 99">
                        <p v-if="jsonData.judge > 0">题型：单选题</p>
                        <p v-if="jsonData.radio > 0">题型：单选题</p>
                        <p v-if="jsonData.checkbox > 0">题型：多选题</p>
                        <p v-if="jsonData.indefinite > 0">题型：共用题干单选题</p>
                        <p v-if="jsonData.compatibility > 0">题型：共用备选答案单选题</p>
                    </div>

                    <div class="infoTest" v-if="tbox == 98">
                        <p>题型间不可回退，请继续完成本部分试题。</p>
                    </div>
                    <div class="infoTest" v-if="tbox == 97">
                        <p>不能返回前面题型查看试题或修改答案哦~</p>
                    </div>
                    <div class="infoTest" v-if="tbox == 95 && paperIds">
                        <p>您还存在未答完的题</p>
                        <p>{{ paperIds }}</p>
                        <p>您确定要交卷吗?交卷后不能继续答题</p>
                    </div>

                    <div class="infoTest" v-if="tbox == 95 && paperIds == ''">
                        <p>您确定要交卷吗?交卷后不能继续答题</p>
                    </div>

                    <div class="infoTest" v-if="tbox == 1">
                        <p>每道试题由1个题干和5个备选答案组成，只有1个为正确答案，其余为干扰选项。</p>
                    </div>
                    <div class="infoTest" v-if="tbox == 4">
                        <p>每道试题有2～6个提问，每个问题有5个备选答案，只有1个为正确答案。答题过程是不可逆的，即进入下一问后不能再返回修改所有前面的答案。
                        </p>
                    </div>
                    <div class="infoTest" v-if="tbox == 5">
                        <p>每连续的2~3个试题使用相同的5个备选答案，每道试题只有1个最佳答案，每个备选答案可被选择1次、多次或不被选择。</p>
                    </div>

                    <div class="infoTest icon" v-if="tbox == 96">
                        <p>一、所有按键均可使用鼠标操作</p>
                        <p>二、考试过程中需要用到的按键</p>
                        <div class="txt">
                            <p>1、按字母<span>A-Z</span>选择相应答案，重新按相应键会删除原来选择的答案。 </p>
                            <p>2、<span>→</span>进入下一题，<span>←</span>进入上一题，<span>2</span>调出计算器，<span>3</span>查看帮助，<span>4</span>交卷。
                            </p>
                            <p>3、答题过程中可以通过点击“帮助”按钮查看该操作说明，并可以查看各题型说明。</p>
                        </div>
                    </div>
                    <div class="t_center">
                        <img v-if="tbox != 95" @click="closeHelp()"
                            src="https://www.yitku.com//new_app/exam/yw_15.png" />

                        <img v-if="tbox == 95" @click="confirmSubmit()"
                            src="https://www.yitku.com//new_app/exam/yw_15.png" />
                        <img v-if="tbox == 95" @click="closeHelp()"
                            src="https://www.yitku.com//new_app/exam/yw_14.png" />

                        <!-- <a v-if="nums < 100" href="javascript:" class="btn" @click="confirmSubmit">确定交卷</a>
                        <a v-if="nums != 0" href="javascript:" class="btn" @click="showSubmit = false">返回作答</a> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="window" v-if="showSubmitSuccess">
            <div class="hs"></div>
            <div class="windowContent">
                <p class="tishi"><img src="https://www.yitku.com//new_app/exam/yw_08.png" />温馨提示</p>
                <div class="delete">
                    <div class="infoTest icon"><span>交卷成功</span></div>
                    <div class="t_center">
                        <a href="javascript:" class="btn" @click="goResult">查看考试成绩</a>
                        <a href="javascript:" class="btn" @click="closeSuccess">返回列表</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

export default {
    data() {
        return {
            showSubmitSuccess: false,
            showSubmit: true,
            dialogVisible: false,
            total: 0,
            jsonData: [],
            questionData: [],
            question: [],
            radioValue: "",
            endDate: new Date().getTime(),
            day: 0,
            hour: "",
            min: "",
            second: "",
            countSecond: "",
            index: 1,
            nums: 0,
            pc_id: 0,
            times: 0,
            radio: 1,
            indefinite: 1,
            compatibility: 1,
            tbox: 99,
            answeredCount: 0,
            totalTimes: 0,
            paperIds: "",
            legendList: [
                { label: '已答', className: 'done' },
                { label: '在答', className: 'doing' },
                { label: '未答', className: 'todo' }
            ],
        };
    },
    mounted: function () {
        //if (this.tbox == 99) {
        // let paper = sessionStorage.getItem('access-mecoPapers');
        // let jsonPaper = JSON.parse(paper);
        // this.jsonData = jsonPaper;
        this.getList();
        //}
    },
    methods: {

        paperSubmit() {
            let _this = this;
            let ids = "";
            //判断跨题库是否上个已经完成
            _this.questionData.forEach((item, index) => {
                if (item.user_answer == "") {
                    ids += (index + 1) + '、';
                }
            });
            _this.showSubmit = true;
            _this.tbox = 95;
            _this.paperIds = ids;
        },

        showHelp() {
            this.tbox = 96;
            this.showSubmit = true;
        },

        closeHelp() {
            if (this.tbox == 99) {
                this.tbox = this.question.type;
            } else {
                this.showSubmit = false;
            }
        },

        radioChange() {
            this.radio = !this.radio;
        },

        indefiniteChange() {
            this.indefinite = !this.indefinite;
        },

        compatibilityChange() {
            this.compatibility = !this.compatibility;
        },

        handleClose() {
            this.dialogVisible = false;
        },

        selectRadio(e) {
            console.log(e);
            console.log(this.question);
            let _this = this;
            if (_this.question.user_answer == '') {
                _this.answeredCount = _this.answeredCount + 1;
            }

            let json = this.questionData;
            let right = 0;
            json[this.index - 1].user_answer = e;
            console.log(this.question.answer);
            if (this.question.answer == e) {
                right = 1;
            }
            json[this.index - 1].user_answer_right = right;
            let formData = {};
            this.questionData = json;
            console.log(this.questionData);
            formData.pc_id = this.pc_id;
            formData.paper_id = this.question.p_id;
            formData.question_id = this.question.id;
            formData.user_answer_right = right;
            formData.user_answer = e;
            this.axios.post("/setPcQuestion", formData).then((res) => {
                if (_this.isAuto == 1) {
                    _this.nextQuestion(_this.index + 1);
                }
            });
        },

        selectCheck(e) {
            console.log(e);
            let es = e.sort();
            let string = es.join("");
            console.log(string);
            let json = this.questionData;
            json[this.index - 1].user_answer = string;
            let right = 0;
            if (this.question.answer == string) {
                right = 1;
            }
            json[this.index - 1].user_answer_right = right;
            this.questionData = json;
            let formData = {};
            this.questionData = json;
            console.log(this.questionData);
            formData.pc_id = this.pc_id;
            formData.paper_id = this.question.p_id;
            formData.question_id = this.question.id;
            formData.user_answer_right = right;
            formData.user_answer = string;
            this.axios.post("/setPcQuestion", formData).then((res) => { });
        },

        submitPaper() {
            let num = 0;
            this.questionData.forEach((element) => {
                if (element.user_answer_right != -1) {
                    num++;
                }
            });
            this.nums = this.total - num;
            console.log(this.nums);
            this.showSubmit = true;
        },

        //点击题号显示对应的题
        nextQuestion(ids) {
            let _this = this;
            if (ids < 1) {
                alert("已经没有题了");
                return false;
            }

            if (ids > this.questionData.length) {
                alert("已经是最后一题了");
                return false;
            }
            this.radioValue = "";
            this.checkList = [];
            let index = ids - 1;
            let finish = 0;
            let question = this.questionData[index];

            if (ids <= 0) {
                return false;
            }

            if (this.question.type == question.type) {
                this.index = ids;
                this.question = this.questionData[index];
            } else {
                //判断跨题库是否上个已经完成
                this.questionData.forEach(item => {
                    if (item.type == this.question.type) {
                        if (item.user_answer == "") {
                            _this.showSubmit = true;
                            _this.tbox = 98;
                            finish++;
                        }
                    }
                })

                if (finish == 0) {
                    if (_this.question.type > question.type) {
                        _this.showSubmit = true;
                        _this.tbox = 97;
                    } else {
                        _this.showSubmit = true;
                        _this.tbox = question.type;
                        _this.index = ids;
                        _this.question = _this.questionData[index];
                    }
                }

            }

            // if (ids > this.questionData.length) {
            //     if (this.question.type == 1 || this.question.type_id == 1) {
            //         this.radioValue = this.question.user_answer;
            //     }
            //     alert("已经是最后一题了");
            //     return false;
            // } else {
            //     if (this.question.type == 1 || this.question.type_id == 1) {
            //         this.radioValue = this.question.user_answer;
            //     } else if (this.question.type == 2 || this.question.type_id == 2) {
            //         this.checkList = this.question.user_answer.split("");
            //     }
            // }


        },

        getList() {
            let that = this;
            let paper = sessionStorage.getItem('access-mecoPapers');
            console.log(JSON.parse(paper));
            let jsonPaper = JSON.parse(paper);
            that.total = jsonPaper.nums;
            that.jsonData = jsonPaper;
            that.questionData = jsonPaper.lists;
            that.question = jsonPaper.lists[jsonPaper.last_id];
            that.index = jsonPaper.last_id + 1;
            that.radioValue = jsonPaper.lists[jsonPaper.last_id].user_answer;
            that.endDate = that.endDate + jsonPaper.stime * 60 * 1000;
            that.answeredCount = jsonPaper.pc;
            that.totalTimes = this.adminApi.secToMin(jsonPaper.stime * 60);
            that.setPcPaper(jsonPaper.id);
            that.countTime();
        },

        //创建记录
        setPcPaper(ids) {
            let that = this;
            let formData = {};
            formData.paper_id = ids;
            that.axios.post("/setPcPaper", formData).then((res) => {
                that.pc_id = res.data;
            });
        },

        // 倒计时
        countTime() {
            let now = new Date().getTime(); // 获取当前时间
            let endDate = new Date(this.endDate); // 设置截止时间
            let end = Number(endDate);
            //let endDate = new Date(this.assistActivityEndTime); // this.assistActivityEndTime需要倒计时的日期
            let leftTime = end - now; // 倒计时时间差
            // 定义变量 d,h,m,s保存倒计时的时间
            if (leftTime >= 0) {
                // 天
                // this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                // let dayh = this.day * 24
                // 时
                let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                h = h;
                this.hour = h < 10 ? "0" + h : h;
                // 分
                let m = Math.floor((leftTime / 1000 / 60) % 60);
                this.min = m < 10 ? "0" + m : m;
                // 秒
                let s = Math.floor((leftTime / 1000) % 60);
                this.second = s < 10 ? "0" + s : s;
                this.countSecond = this.hour + ":" + this.min + ":" + this.second;
            } else {
                this.day = 0;
                this.hour = "00";
                this.min = "00";
                this.second = "00";
                this.countSecond = this.hour + ":" + this.min + ":" + this.second;
                this.confirmSubmit();
            }
            // 等于0的时候不调用
            if (
                Number(this.day) === 0 &&
                Number(this.hour) === 0 &&
                Number(this.min) === 0 &&
                Number(this.second) === 0
            ) {
                this.$route.query.count = 4;
                // 执行飞行任务
                return;
            } else {
                // 递归每秒调用countTime方法，显示动态时间效果,
                this.times = this.times + 1;
                setTimeout(this.countTime, 1000);
            }
        },

        //提交试卷
        confirmSubmit() {
            //this.showSubmitSuccess = true;pc_id: this.pc_id,
            let that = this;
            let formData = {};
            formData.pc_id = that.pc_id;
            formData.times = that.times;
            formData.question = that.questionData;
            that.axios.post("/setSubmitPaper", formData).then((res) => {
                this.showSubmitSuccess = true;
            });

        },

        closeSuccess() {
            let _this = this;
            sessionStorage.setItem("access-class_id", this.jsonData.class_id);
            sessionStorage.setItem("access-column_id", this.jsonData.column_id);
            sessionStorage.setItem("access-subject_id", this.jsonData.subject_id);
            this.$router.push({
                path: "/web/chapter",
                query: {
                    class_id: this.jsonData.class_id,
                    column_id: this.jsonData.column_id,
                    subject_id: this.jsonData.subject_id,
                },
            });
        },

        goResult() {
            this.$router.push({
                path: "/meco/result",
                query: {
                    pc_id: this.pc_id,
                    column_id: this.jsonData.column_id,
                },
            });
        },

    }
}
</script>

<style scoped>
.page {
    min-height: 100%;
    background: #1886ca;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.page {
    min-height: 100vh;
    background: linear-gradient(180deg, #2592d5 0%, #1f85c5 36%, #1465ad 100%);
}

.question-material {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #fff;
    padding: 10px;
    line-height: 26px;
}

.paper-shell {
    max-width: 1400px;
    min-height: 100vh;
    margin: 0 auto;
    background: #1b85c8;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.18);
}

.window-bar {
    height: 30px;
    padding: 0 8px;
    background: linear-gradient(180deg, #8ea7e6 0%, #3f61c4 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}

.window-title {
    position: relative;
    padding-left: 20px;
    font-size: 14px;
    color: #ffffff;
}

.window-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    width: 14px;
    height: 12px;
    background: #ffffff;
    border-radius: 1px;
}

.window-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.window-btn {
    width: 18px;
    height: 18px;
    border: 1px solid rgba(255, 255, 255, 0.58);
    box-sizing: border-box;
    cursor: pointer;
}

.window-btn.small,
.window-btn.square {
    background: #4f6ed5;
}

.window-btn.close {
    background: #c53e39;
}

.exam-topbar {
    padding: 8px 18px 10px;
    background: linear-gradient(180deg, #1492d4 0%, #0f7abc 100%);
    color: #ffffff;
    box-sizing: border-box;
}

.exam-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.exam-line.second {
    margin-top: 6px;
    justify-content: flex-start;
}

.exam-item {
    font-size: 16px;
    line-height: 1.3;
}

.exam-item.seat {
    margin-left: auto;
}

.seat-highlight {
    font-size: 20px;
    font-weight: 700;
    margin-left: 4px;
}

.legend-row {
    display: flex;
    gap: 18px;
    margin-left: 100px;
    margin-right: 50px;
}

.legend-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
}

.legend-box {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border: 2px solid rgba(255, 255, 255, 0.9);
    box-sizing: border-box;
}

.legend-box.done {
    background: #0b9bda;
}

.legend-box.doing {
    background: #ff6612;
}

.legend-box.todo {
    background: #f3f3f3;
}

.main-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 10px;
    padding: 0 6px 0 6px;
    box-sizing: border-box;
}

.question-panel {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 126px);
}

.question-card {
    min-height: 84px;
    background: #d4edf7;
    display: grid;
    grid-template-columns: 80px minmax(0, 1fr);
    align-items: center;
}

.question-no {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #035b9b;
}

.question-body {
    padding: 18px 20px 18px 8px;
    font-size: 16px;
    line-height: 1.72;
    color: #111111;
}

.answer-panel {
    flex: 1;
    background: #ffffff;
    padding: 18px 48px 24px 52px;
    box-sizing: border-box;
}

.option-row {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 1.6;
    color: #111111;
    margin-bottom: 18px;
    cursor: pointer;
}

.option-key {
    width: 24px;
    color: #034b98;
    font-size: 18px;
}

.option-radio {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    border-radius: 50%;
    border: 2px solid #0b61b5;
    box-sizing: border-box;
}

.option-radio.active {
    background: radial-gradient(circle, #0b61b5 0 48%, transparent 52% 100%);
}

.action-row {
    display: flex;
    align-items: center;
    gap: 28px;
    padding: 10px 14px 8px;
    background: #1887ca;
    box-sizing: border-box;
    justify-content: center;
}

.action-btn {
    height: 44px;
    padding: 0 18px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #ffffff;
    white-space: nowrap;
    box-sizing: border-box;
    cursor: pointer;
}

.action-btn.submit {
    padding-left: 24px;
    padding-right: 24px;
}

.action-icon {
    position: relative;
    margin-right: 8px;
    flex-shrink: 0;
}

.left-arrow,
.right-arrow {
    width: 24px;
    height: 24px;
}

.arrow-head {
    position: absolute;
    top: 4px;
    width: 10px;
    height: 10px;
    border-left: 4px solid #72d000;
    border-bottom: 4px solid #72d000;
}

.left-arrow .arrow-head {
    left: 0;
    transform: rotate(45deg);
}

.right-arrow .arrow-head {
    right: 0;
    transform: rotate(225deg);
}

.arrow-tail {
    position: absolute;
    top: 9px;
    width: 12px;
    height: 5px;
    background: #72d000;
    border-radius: 999px;
}

.left-arrow .arrow-tail {
    left: 8px;
}

.right-arrow .arrow-tail {
    left: 4px;
}

.calc-icon,
.help-icon,
.submit-icon {
    width: 22px;
    height: 22px;
}

.calc-body {
    width: 20px;
    height: 18px;
    margin-top: 2px;
    border: 2px solid #56606a;
    background: linear-gradient(180deg, #ffffff 0%, #dfe7ef 100%);
    box-sizing: border-box;
    position: relative;
}

.calc-body::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 4px;
    background: #56606a;
}

.help-dot {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: radial-gradient(circle, #6dd7ff 0%, #2ca9e8 72%, #1a7eca 100%);
    border: 2px solid rgba(255, 255, 255, 0.72);
    font-size: 15px;
    font-weight: 700;
    line-height: 18px;
    span-align: center;
    color: #ffffff;
    box-sizing: border-box;
}

.submit-dot {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: radial-gradient(circle, #c0ff8d 0%, #7cf300 50%, #35b700 100%);
    border: 2px solid rgba(255, 255, 255, 0.8);
    box-sizing: border-box;
}

.bottom-status {
    display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 0;
    background: #0b5694;
    color: #ffffff;
}

.time-group,
.progress-group {
    height: 68px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.time-group {
    font-size: 18px;
}

.time-highlight {
    font-size: 22px;
    color: #ffef54;
}

.gap-space {
    margin-left: 12px;
}

.progress-group {
    gap: 16px;
    font-size: 14px;
}

.progress-line {
    flex: 1;
    height: 16px;
    background: #f4f4f4;
}

.progress-fill {
    width: 10%;
    height: 100%;
    background: #7ade00;
}

.progress-percent {
    font-size: 24px;
}

.sheet-panel {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 0;
    height: 89vh;
    overflow: auto;
}

.sheet-card {
    background: #bfe2ef;
    padding: 8px 8px 10px;
    box-sizing: border-box;
}

.sheet-header {
    height: 34px;
    padding: 0 12px;
    background: #0f73bc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
}

.sheet-arrow {
    font-size: 14px;
}

.sheet-grid {
    padding: 10px 0px 0;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
}

.sheet-number {
    height: 36px;
    width: 36px;
    border-radius: 3px;
    background: #f6f6f6;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    cursor: pointer;
}

.sheet-number.done {
    background: #07a1e0;
    border-color: #ffffff;
    color: #ffffff;
}

.sheet-number.doing {
    background: #ff6612;
    border-color: #ffffff;
    color: #ffffff;
}

.hs,
.window {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999
}

.hs .hs,
.window .hs {
    background: #666;
    z-index: 999;
    filter: Alpha(opacity=50);
    opacity: .5
}

.hs .windowContent,
.window .windowContent {
    width: 500px;
    background: linear-gradient(0deg, #EDEDED 0%, #C8C8C8 100%);
    border-radius: 10px 10px 10px 10px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    z-index: 999;
    left: 50%;
    margin-left: -250px;
    top: 50%;
    margin-top: -140px;
    position: absolute;
    height: 280px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.hs .windowContent .tishi,
.window .windowContent .tishi {
    height: 46px;
    line-height: 46px;
    padding-left: 20px;
    font-size: 18px;
    margin-top: 0;
    color: #1A3558;
    display: flex;
    align-items: center;
    font-weight: bold;
}

.window .windowContent .tishi img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
}

.hs .windowContent .infoTest,
.window .windowContent .infoTest {
    font-size: 16px;
    color: #000000;
    text-align: left;
    min-height: 100px;
    width: 450px;
    padding: 10px;
    min-height: 165px;
    border-radius: 5px;
    margin: 10px auto;
    line-height: 30px;
    background-color: #ffffff;
}

.hs .windowContent .infoTest .txt,
.window .windowContent .infoTest .txt {
    font-size: 12px;
    color: #1F5B89;
    line-height: 23px;
}

.hs .windowContent .infoTest span,
.window .windowContent .infoTest span {
    color: #D6435C;
}

.hs .windowContent .infoTest.icon,
.window .windowContent .infoTest.icon {
    color: #e8661b;
}

.hs .windowContent .t_center,
.window .windowContent .t_center {
    text-align: center
}

.window .windowContent .t_center img {
    cursor: pointer;
    margin: 0 20px;
}

.hs .windowContent .t_center .btn,
.window .windowContent .t_center .btn {
    border-radius: 3px;
    width: 120px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #fff;
    background-color: #1d7ecc;
    font-size: 14px;
    display: inline-block
}

.hs .windowContent .t_center .btn+.btn,
.window .windowContent .t_center .btn+.btn {
    margin-left: 20px;
    background: #e7661d
}


@media screen and (max-width: 1180px) {
    .main-layout {
        grid-template-columns: minmax(0, 1fr) 280px;
    }

    .question-body {
        font-size: 20px;
    }

    .answer-panel {
        padding-left: 26px;
        padding-right: 26px;
    }

    .action-row {
        gap: 12px;
        flex-wrap: wrap;
    }
}

@media screen and (max-width: 960px) {
    .main-layout {
        grid-template-columns: 1fr;
    }

    .question-panel {
        min-height: auto;
    }

    .question-card {
        grid-template-columns: 1fr;
    }

    .question-no {
        padding-top: 16px;
    }

    .question-body {
        padding-top: 8px;
    }

    .bottom-status {
        grid-template-columns: 1fr;
    }

    .time-group,
    .progress-group {
        height: auto;
        padding-top: 12px;
        padding-bottom: 12px;
        flex-wrap: wrap;
    }

    .legend-row {
        margin-left: 0;
    }

    .exam-item.seat {
        margin-left: 0;
    }
}
</style>